<template>
  <section class="prod-grid" :class="grid">
    <div class="prod-grid__wrap">
        <SinglePrduct
          v-for="product in products"
          :key="product.sku"
          :product="product"
        />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SinglePrduct from "./SingleProduct.vue";

export default {
  name: "Products",
  components: {
    SinglePrduct,
  },
  computed: {
    ...mapState("products", ["grid"]),
    ...mapGetters("products", ["products"]),
    // ...mapGetters({
    //   products: "products/filterProd",
    // }),
    // products() {
    //   // return this.$store.state.products.products.filter((item) => {
    //   //   console.log(+item.dist <= this.radius, +item.dist, this.radius);
    //   //   return +item.dist <= this.radius;
    //   // });
    // },
    // radius() {
    //   return this.$store.state.map.radius;
    // },
  },
};
</script>
